import React from "react";

export default function InfoIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_81_3052)">
    <path d="M2.5 10.5386C2.5 11.5235 2.69399 12.4988 3.0709 13.4087C3.44781 14.3186 4.00026 15.1454 4.6967 15.8419C5.39314 16.5383 6.21993 17.0908 7.12987 17.4677C8.03982 17.8446 9.01509 18.0386 10 18.0386C10.9849 18.0386 11.9602 17.8446 12.8701 17.4677C13.7801 17.0908 14.6069 16.5383 15.3033 15.8419C15.9997 15.1454 16.5522 14.3186 16.9291 13.4087C17.306 12.4988 17.5 11.5235 17.5 10.5386C17.5 8.54945 16.7098 6.6418 15.3033 5.23527C13.8968 3.82875 11.9891 3.03857 10 3.03857C8.01088 3.03857 6.10322 3.82875 4.6967 5.23527C3.29018 6.6418 2.5 8.54945 2.5 10.5386Z" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 8.03857H10.0083" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.16675 10.5386H10.0001V13.8719H10.8334" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_81_3052">
    <rect width="20" height="20" fill="white" transform="translate(0 0.538574)"/>
    </clipPath>
    </defs>
    </svg>
    

  );
}
